import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import './com-table.less'

import ComCheckbox from './com-checkbox'
import EmptyImg from './empty_img.png'

/*
 * props参数
 * center: 表格数据是否全部居中
 * columns: 每一列数据(表头)
 * ****** label: thead列的名称
 * ****** prop: 表格字段名称
 * ****** type: 是否为多选表格 type=selection
 * ****** width: 列的宽度
 * ****** center: 是否居中
 * ****** render: 自定义渲染方法 (当前行数据, 当前节点) => {}
 * 
 * datas: 列表数据
 * rowKey: 列表用作标识的key，默认取id
 * emptyTip: 空状态文案描述
 * rowClick: 触发单元格点击事件
 * onSelectAll: 用户手动选择/取消选择所有行的回调
 * onSelect: 用户手动选择/取消选择某行的回调
 */ 

const ComTable = ({ emptyTip='暂无数据', ...props }) => {
  const [state, setState] = useState({
    list: [],
    checkType: '',
    selectList: []
  })
  useEffect(() => {
    setState(pre => ({ ...pre, list: props.datas ? JSON.parse(JSON.stringify(props.datas)) : [] }))
  }, [props.datas])

  const tdClickFun = (e, item, isRender) => {
    if (isRender) props.rowClick && props.rowClick(e, item);
  }
  const selectAllChange = (checked) => {    //全选值变动了
    let { list, selectList } = state;
    list.forEach(item => item.checked = checked);
    selectList = checked ? JSON.parse(JSON.stringify(list)) : [];
    setState(pre => ({
      ...pre,
      list, 
      selectList, 
      checkType: checked ? 'all' : ''
    }))
    props.onSelectAll && props.onSelectAll(selectList);
  }
  const selectChange = (checked, row) => {    //多选框值变动了
    let { list, selectList } = state, _key = props.rowKey || 'id';
    let _idx = list.findIndex(item => item[_key]==row[_key]);
    list[_idx].checked = checked;

    let _slIdx = selectList.findIndex(item => item[_key]==row[_key]);
    if (_slIdx==-1 && checked) selectList.push(row);
    if (_slIdx!=-1 && !checked) selectList.splice(_slIdx, 1);

    let _len = list.length, _slLen = selectList.length;
    setState(pre => ({
      ...pre,
      list, 
      selectList, 
      checkType: _slLen ? (_slLen==_len ? 'all' : 'part') : ''
    }))
    props.onSelect && props.onSelect(selectList);
  }

  return (
    <div className='com-table-wrap'>
      <table className={`com-table ${props.center?'is-center':''}`} cell-bordered='false'>
        <thead className="com-thead">
          <tr className="com-th-row row">
            {props.columns.map((item, index) =>
              <th className={`com-th ${item.center?'is-center':''} ${item.type=='selection'?'com-td-selection':''}`} key={index} style={{width: (item.width ? (item.width+'rem') : '')}}>
                {item.type!='selection' ? item.label : <ComCheckbox checkType={state.checkType} checked={state.checkType=='all'} change={selectAllChange}></ComCheckbox>}
              </th>
            )}
          </tr>
        </thead>
        <tbody className="com-tbody">
          {state.list && state.list.map((m, n) => 
            <tr className="com-tr-row" key={n}>
              {props.columns.map((item, index) => 
                <td className={`com-td ${item.center?'is-center':''} ${item.type=='selection'?'com-td-selection':''}`} style={{width: (item.width ? (item.width+'rem') : '')}} key={index} onClick={e => tdClickFun(e, m, !!item.render)}>
                  { item.type=='selection' ? <ComCheckbox row={m} checked={m.checked} isRow={true} change={selectChange}></ComCheckbox> :
                    item.render ? item.render(m, item) : 
                    (item.prop ? m[item.prop] : '') 
                  }
                </td>
              )}
            </tr>
          )}
        </tbody>
      </table>
      {
        !state.list || (state.list && state.list.length) ? '' : 
        <div className="com-empty">
          <img className="com-empty-img" src={EmptyImg} alt="" />
          <p className="com-empty-tip">{emptyTip}</p>
        </div>
      }
    </div>
  )
}

export default withRouter(ComTable);